export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Versión", size: 5, order: "" },
	{ name: "Estable", size: 5, order: "" },
	{ name: "API", size: 10, order: "" },
	{ name: "Front", size: 10, order: "" },
	{ name: "Cant. Clientes", size: 10, order: "" },
	{ name: "Estado", size: 5, order: "" },
	{ name: "Acción", size: 10, order: "" },
];

export const base_list = {
	page: 1,
	paginate: 10,
	order: "name",
	orderType: "desc",
};

export const base_element = {
	id: "",
	version: "",
	git_restoration_point_driver: "",
	git_restoration_point_app: "",
	active: "",
	stable: "",
	customers: [],
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
